import { queryOptions, useQuery } from '@tanstack/react-query'
import { getBlogs } from '../services/getBlogs.service'
import { blogsKeys } from '../constants/blogs.queryKeys'
import type { BlogListParams } from '../types/blog.types'

export const blogsQueryOptions = (params: BlogListParams = {}) =>
  queryOptions({
    queryKey: blogsKeys.list(params),
    queryFn: () => getBlogs(params),
  })

export function useBlogs(params: BlogListParams = {}) {
  return useQuery(blogsQueryOptions(params))
}
